import ChannelNoti from '@/api/ChannelNoti'

// initial state
const state = {
  line_list: [],
  email_list: [],
}

// getters
const getters = {
  getLineList: state => state.line_list,
  getEmailList: state => state.email_list,
}

// mutations
const mutations = {
  setState (state, options) {
    state[options.key] = options.data
  },
}

// actions
const actions = {

  async getChannelNotis ({ commit }, data) {
    var result = null

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getChannelNotis')

      let response = await ChannelNoti.getAll()

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getChannelNotis')

      result = response.data

      if (result.success) {
        var line_list = []
        var email_list = []

        result.data.map(obj => {
          switch (obj.channel) {
            case 'line':
              line_list.push(obj)
              break
            case 'email':
              email_list.push(obj)
              break
          }
        })

        commit('setState', {
          key: 'line_list',
          data: line_list,
        })

        commit('setState', {
          key: 'email_list',
          data: email_list,
        })
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }

    return result
  },

  async insertChannelNoti ({ commit }, data) {
    var result = null

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'insertChannelNoti')

      let response = await ChannelNoti.insert(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'insertChannelNoti')

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }

    return result
  },

  async updateChannelNoti ({ commit }, data) {
    var result = null

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'updateChannelNoti')

      let response = await ChannelNoti.update(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'updateChannelNoti')

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }

    return result
  },

  async deleteChannelNoti ({ commit }, data) {
    var result = null

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'deleteChannelNoti')

      let response = await ChannelNoti.delete(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'deleteChannelNoti')

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }

    return result
  },

}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/ChannelNoti.js